var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdrawSubmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 5.76562H3.10742L6.82812 2.57227C7.12109 2.30859 7.15039 1.86914 6.91602 1.57617C6.65234 1.2832 6.21289 1.25391 5.91992 1.48828L0.763672 5.91211C0.617188 6.08789 0.5 6.26367 0.5 6.46875C0.5 6.67383 0.617188 6.87891 0.763672 7.02539L5.91992 11.4492C6.03711 11.5664 6.21289 11.625 6.35938 11.625C6.56445 11.625 6.76953 11.5371 6.91602 11.3613C7.15039 11.0684 7.12109 10.6289 6.82812 10.3652L3.10742 7.17188H11.0469C12.7461 7.17188 14.0938 8.51953 14.0938 10.1895V13.6758C14.0938 14.1445 14.416 14.4375 14.7969 14.4375C15.207 14.4375 15.5 14.1445 15.5 13.7344V10.248C15.5 7.78711 13.5078 5.76562 11.0469 5.76562Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawSubmission);
export default __webpack_public_path__ + "static/media/withdraw_submission.6489b97a9c5cb79037d097b38991c501.svg";
export { ForwardRef as ReactComponent };